import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

/**
 * One assignment set to a linked child, fetched on its own so a link to it
 * opens without the list it belongs to.
 *
 * Responds 404 when the assignment is not set to that child, 403 when the child
 * is not linked to the authenticated parent.
 */
export function useGetChildAssignment(childId: number | undefined, assignmentId: number | undefined, enabled = true) {
  const query = useQuery({
    queryKey: [ParentKey.CHILD_ASSIGNMENT, childId, assignmentId],
    queryFn: () => ParentService.getChildAssignment(childId as number, assignmentId as number).then((response) => response.data),
    enabled: enabled && typeof childId === 'number' && typeof assignmentId === 'number',
  });
  const errorMessage = useErrorMessage(query.error, baseErrorMessages);
  return { ...query, errorMessage };
}
